module.exports = __webpack_public_path__ + "static/img/verify1.254a13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify1.png
// module id = sCb+
// module chunks = 0